import {Box} from '@mui/material';
import {useOptimisticSearchParams} from 'nuqs/adapters/react-router/v7';
import {useEffect, useRef} from 'react';
import {useSearchParams} from 'react-router';
import {useEffectEvent} from 'use-effect-event';
import CollectionSelection from './CollectionSelection.tsx';
import ConfigurationSelection from './ConfigurationSelection.tsx';
import Highlights from './Highlights.tsx';
import VisualizeButton from './VisualizeButton.tsx';
import {useGetConfigurationCollections} from '@src/api/configurations.ts';
import {ANALYZE_RESTORE_PARAM} from '@src/constants/routes.ts';
import {useMapExtentHandler} from '@src/hooks/useMapExtentHandler.ts';
import useVisualizationParams from '@src/hooks/useVisualizationParams.ts';
import dimensions from '@src/styles/dimensions.ts';

export const Browse = () => {
  const searchParams = useOptimisticSearchParams();
  const [, setSearchParams] = useSearchParams();
  const configurationChangedRef = useRef(false);
  const {configurationId, collectionId} = useVisualizationParams();
  const {collections, isLoading} =
    useGetConfigurationCollections(configurationId);

  const restoreFlag = searchParams?.has(ANALYZE_RESTORE_PARAM);
  const firstCollectionId = collections[0]?.id;
  const handleCollectionChange = useMapExtentHandler();

  const initCollectionIdEvent = useEffectEvent(() => {
    searchParams?.delete(ANALYZE_RESTORE_PARAM);
    setSearchParams(searchParams);
    handleCollectionChange(collectionId ?? firstCollectionId, '');
  });

  useEffect(() => {
    if (!isLoading && configurationChangedRef.current) {
      initCollectionIdEvent();
    }
  }, [configurationId, isLoading]);

  useEffect(() => {
    if (!isLoading && restoreFlag) {
      initCollectionIdEvent();
    }
  }, [isLoading, restoreFlag]);

  return (
    <>
      <ConfigurationSelection changedRef={configurationChangedRef} />
      <Box
        sx={{
          flexGrow: 1,
          overflowBlock: 'auto',
          display: 'flex',
          flexDirection: 'column',
          marginInline: `-${dimensions.leftSidebar.contentMargin}px`,
        }}
      >
        <CollectionSelection />
        <VisualizeButton />
        <Highlights />
      </Box>
    </>
  );
};

export default Browse;
